import { render, staticRenderFns } from "./TalentMappingV2.vue?vue&type=template&id=11c2c1aa"
import script from "./TalentMappingV2.vue?vue&type=script&lang=ts"
export * from "./TalentMappingV2.vue?vue&type=script&lang=ts"
import style0 from "./TalentMappingV2.vue?vue&type=style&index=0&id=11c2c1aa&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./TalentMappingV2.vue?vue&type=custom&index=0&blockType=fieldset&disabled=disabled"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11c2c1aa')) {
      api.createRecord('11c2c1aa', component.options)
    } else {
      api.reload('11c2c1aa', component.options)
    }
    module.hot.accept("./TalentMappingV2.vue?vue&type=template&id=11c2c1aa", function () {
      api.rerender('11c2c1aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/companyContractors/TalentMappingV2.vue"
export default component.exports